enum FeatureEnum {
  TM3_CLASSES_ENABLED = 'TM3_CLASSES_ENABLED',
  PRONTO_INTEGRATION = 'PRONTO_INTEGRATION',
  USER_DIARY_RESTRICTION = 'USER_DIARY_RESTRICTION',
  TM3_HEALTHCODE = 'TM3_HEALTHCODE',
  ROLE_MANAGER = 'ROLE_MANAGER',
  TM3_VIDEO_ENABLED = 'TM3_VIDEO_ENABLED',
  CASEFLOW_PREREFERRAL_INFORMATION = 'CASEFLOW_PREREFERRAL_INFORMATION',
  CASEFLOW_PATIENT_PORTAL = 'CASEFLOW_PATIENT_PORTAL',
  CASEFLOW_REFERRAL_PORTAL = 'CASEFLOW_REFERRAL_PORTAL',
  CASEFLOW_EDITABLE_PRICING = 'CASEFLOW_EDITABLE_PRICING',
  MEDIPASS_ACTIVE = 'MEDIPASS_ACTIVE',
  QSW_ENABLED = 'QSW_ENABLED',
  MY_CLINIC_INTEGRATION = 'MY_CLINIC_INTEGRATION',
  UPGRADE_ENABLED = 'UPGRADE_ENABLED',
  FIX_LEGACY_ANNOTATIONS_CONVERSION = 'FIX_LEGACY_ANNOTATIONS_CONVERSION',
  FF_NEW_DOCS_UI = 'FF_NEW_DOCS_UI',
  FF_DIARY_COLOURS = 'FF_DIARY_COLOURS',
  PRONTO_ROADMAP_PHASE_ONE = 'PRONTO_ROADMAP_PHASE_ONE',
  FF_CASE_NOTES = 'FF_CASE_NOTES',
  APPOINTMENT_PREPAYMENT = 'APPOINTMENT_PREPAYMENT',
  FF_DX_DASHBOARDS = 'FF_DX_DASHBOARDS',
  SQUARE = 'FF_SQUARE',
  AUTOMATIONS_VNEXT = 'FF_AUTOMATIONS_VNEXT',
  FF_REPORTS = 'FF_REPORTS',
  FF_NW_LOCATION_FACILITIES = 'FF_NW_LOCATION_FACILITIES',
  FF_VHG_MITEL_CHAT = 'FF_VHG_MITEL_CHAT',
  FF_NEW_REFERRAL_PORTAL = 'FF_NEW_REFERRAL_PORTAL',
  FF_DEFAULT_CLEAR_ACCEPT = 'FF_DEFAULT_CLEAR_ACCEPT',
  FF_ACCOUNTING_INTEGRATION_ENABLED = 'FF_ACCOUNTING_INTEGRATION_ENABLED',
  FF_ALLOW_CUSTOM_SMS = 'FF_ALLOW_CUSTOM_SMS',
  STOCK_LEVELS = 'FF_STOCK_LEVELS',
  BUSINESS_SETTINGS_RP = 'FF_BUSINESS_SETTINGS_RP',
  FF_CEMPLICITY = 'FF_CEMPLICITY',
  WAITING_LIST_PAYMENTS_ENABLED = 'WAITING_LIST_PAYMENTS_ENABLED',
  FF_Embeddable = 'FF_Embeddable',
  FF_NEWUX = 'FF_NEWUX',
  FF_BLOCK_EDITOR = 'FF_BLOCK_EDITOR',
  FF_NEWUX_CONTACTS = 'FF_NEWUX_CONTACTS',
  FF_NEWUX_PRACTITONERS = 'FF_NEWUX_PRACTITONERS',
  FF_CONNECT_HIDE_FROM_EXPLORE = 'FF_CONNECT_HIDE_FROM_EXPLORE',
  FF_GDS_PARTS_CATALOGUE = 'FF_GDS_PARTS_CATALOGUE',
  FF_TM3_STRIPE_TERMINALS = 'FF_TM3_STRIPE_TERMINALS',
  FF_TAX_EXEMPTION = 'FF_TAX_EXEMPTION',
  FF_DX_LETTER_EDITOR = 'FF_DX_LETTER_EDITOR',
  FF_SSO_ENABLED = 'FF_SSO_ENABLED',
  FF_SSO_GOOGLE = 'FF_SSO_GOOGLE',
  FF_SSO_FACEBOOK = 'FF_SSO_FACEBOOK',
  FF_SSO_MICROSOFT = 'FF_SSO_MICROSOFT',
  FF_SSO_APPLE = 'FF_SSO_APPLE',
  FF_NEW_SEARCH = 'FF_NEW_SEARCH'
}

export default FeatureEnum;
